module.exports = __webpack_public_path__ + "img/corpolex_logo_image_round.6e54474d.png";